import { render, staticRenderFns } from "./CurrentAgeCount.vue?vue&type=template&id=ccf02c02&scoped=true"
import script from "./CurrentAgeCount.vue?vue&type=script&lang=ts"
export * from "./CurrentAgeCount.vue?vue&type=script&lang=ts"
import style0 from "./CurrentAgeCount.vue?vue&type=style&index=0&id=ccf02c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf02c02",
  null
  
)

export default component.exports